import { useMemo } from 'react';
import { Filter, ProductClass } from '../../../../types/catalog';
import FilterAccordion from './filter-accordion';
import ClassAccordion from './class-accordion';
import { FilterValues } from '../../../catalog';
import Search from './search';

interface FilterSidebarProps {
    showSearch: boolean;
    setQuery: (q: string) => void;
    filters: Filter[];
    filterValues: FilterValues;
    classes: ProductClass[];
    setClassId: (id: string | null) => void;
    toggleFilterValue: (filterIdx: number, valueIdx: number) => void;
}

function FilterSidebar({
    showSearch,
    setQuery,
    filters,
    filterValues,
    classes,
    setClassId,
    toggleFilterValue,
}: FilterSidebarProps) {
    const visibleFilters = useMemo(
        () => filters.map((f, idx) => [f, idx] as [Filter, number]).filter(([f]) => f.values.length > 1),
        [filters]
    );
    return (
        <div className="iek-prodcat-catalog-section-filter">
            {showSearch && (
                <div className="catalog-section-tree__title">
                    <Search placeholder="Поиск по текущему разделу" onSearch={(q) => setQuery(q)} />
                </div>
            )}
            <div className="iek-prodcat-catalog-section-filter-form">
                <div className="iek-prodcat-catalog-section-filter__title">Подбор по параметрам</div>
                <div className="iek-prodcat-catalog-section-filter-block" style={{ margin: '10px 0' }}>
                    <div className="iek-prodcat-catalog-section-filter-block__title">
                        <div
                            className="iek-prodcat-catalog-section-filter-block__name-wrap"
                            style={{ boxSizing: 'border-box', padding: '8px 22px' }}
                        >
                            <div className="iek-prodcat-catalog-section-filter-block__name">
                                <a
                                    href="https://oni-system.com/produktsiya/configurators/oni-equipment/"
                                    rel="noreferrer"
                                    target="_blank"
                                    style={{ color: '#fff' }}
                                >
                                    Конфигуратор подбора оборудования ONI
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {classes.length > 1 && <ClassAccordion classes={classes} setClassId={setClassId} />}
                {visibleFilters.length > 0 &&
                    visibleFilters.map(([f, idx], conIdx) => (
                        <FilterAccordion
                            key={f.id}
                            {...f}
                            selected={filterValues[f.id] || []}
                            openDefault={conIdx < 4 || filterValues[f.id]?.length > 0}
                            toggleValue={(f) => toggleFilterValue(idx, f)}
                        />
                    ))}
            </div>
        </div>
    );
}

export default FilterSidebar;
